import { render, staticRenderFns } from "./threeFourTableCell.vue?vue&type=template&id=83904e4c&scoped=true&"
import script from "./threeFourTableCell.vue?vue&type=script&lang=js&"
export * from "./threeFourTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83904e4c",
  null
  
)

export default component.exports